import React, { FC } from 'react'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import media from 'styles/media'

interface Props {
  customNoteSection: boolean
}

const { screenXsMax } = media

const ModalProductModifiersSkeleton: FC<Props> = ({ customNoteSection }) => {
  return (
    <Wrapper>
      <Title>
        <Skeleton width="170px" height={23} />
      </Title>
      <Content>
        {customNoteSection && (
          <CustomNote>
            <Skeleton width="40%" height={23} />
            <Skeleton width="100%" height={90} />
          </CustomNote>
        )}

        <Footer>
          <ModifierQuantity>
            <Skeleton circle width={38} height={38} />
            <Skeleton width={55} height={42} />
            <Skeleton circle width={38} height={38} />
          </ModifierQuantity>
          <ButtonSaveWarpper>
            <Skeleton width="100%" height="100%" borderRadius={27} />
          </ButtonSaveWarpper>
        </Footer>
      </Content>
    </Wrapper>
  )
}

export default ModalProductModifiersSkeleton

const Wrapper = styled.div``

const Title = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -23px;
`

const Content = styled.div`
  padding-top: 25px;
`

const CustomNote = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.S};
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
`

const ModifierQuantity = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.M};
  padding-right: ${({ theme }) => theme.spacing.S};
`

const ButtonSaveWarpper = styled.div`
  width: 150px;
  height: 54px;
  /* height: ; */
  @media (${screenXsMax}) {
    width: 130;
    height: 45px;
  }
`
